import { createSlice } from '@reduxjs/toolkit';
import getAdapter from '../getAdapter';

const tireSizesAdapter = getAdapter();

const tireSizesSlice = createSlice({
  name: 'tireSizes',
  initialState: tireSizesAdapter.getInitialState(),
  reducers: {
    setTireSizes: (state, { payload: { tireSizes } }) => {
      tireSizesAdapter.setAll(state, tireSizes);
    }
  }
});

const selectors = tireSizesAdapter.getSelectors(({ tireSizes }) => tireSizes);

export const getTireSizes = state => selectors.selectAll(state);

export const { setTireSizes } = tireSizesSlice.actions;

export default tireSizesSlice.reducer;
